import React from 'react';
import deparam from 'jquery-deparam';

import jsonAjax from '../helpers/jsonAjax';

class SearchAgent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      agentData:  {name: 'Hakuagentti', email: '', type: props.type,},
      isVisible: false,
    };
    this.onFormChange = this.onFormChange.bind(this)
  }
  componentDidMount() {
    jsonAjax({type:'GET',url:'/_ajax/users/current_user/'}).done((res) => {
      if (res.user.email) {
        this.setState({
          agentData: {
            ...this.state.agentData,
            email: res.user.email,
          }
        });
      }
    })
  }
  showWindow() {
    this.setState({isVisible: true});
  }
  closeWindow() {
    this.setState({isVisible: false});
  }
  onFormChange(e) {
    const { name, value } = e.target,
          fieldData = {[name]: value},
          oldData = this.state.agentData,
          newData = {...oldData, ...fieldData};

    this.setState({agentData: newData});
  }
  render() {
    const { agentData, isVisible } = this.state;
    return (
      <div>
        {this.renderButton()}
        { isVisible
          ? <SearchAgentWindow data={agentData}
                               close={() => this.closeWindow()}
                               onChange={this.onFormChange} />
          : null
        }
      </div>
    );
  }
  renderButton() {
    return (
      <a className="btn search-agent-toggle" onClick={() => this.showWindow()}>
        Luo hakuagentti
      </a>
    );
  }
}

class SearchAgentWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isSaving: false};
  }
  render() {
    const { close, data, onChange } = this.props,
          { isSaving } = this.state;
    return (
      <div>
        <div className="search-agent-dim" onClick={close}></div>
        <div className="search-agent-window">
          <h1>Hakuagentti</h1>
          <p>Hakuagentin avulla tallennat nykyisen haun ja saat ilmoituksen uusista
             autoosi sopivista tuotteista suoraan sähköpostiisi.</p>
          <br/>
          {form(data, onChange, isSaving, this.submit.bind(this))}
        </div>
      </div>
    );
  }
  submit(e) {
    e.preventDefault();

    const { target } = e;
    if (target.checkValidity()) {
      this.setState({isSaving: true});
      saveSearchAgent(this.props.data).done((data) => {
        this.setState({isSaving: false});
        this.props.close();
      })
    } else {
      target.reportValidity();
    }
  }
}

const fieldConfig = {
  name: {
    label: 'Agentin nimi',
    type: 'text',
    placeholder: '',
    required: true,
  },
  email: {
    label: 'Sähköposti',
    type: 'email',
    placeholder: 'pakollinen',
    required: true,
  },
  type: {
    label: '',
    type: 'hidden',
    placeholder: '',
    required: false,
  }
};

const form = (data, onChange, isSaving, submit) => {
  const fields = Object.entries(data).map(([k, v]) => formField(k, v, fieldConfig[k], onChange));
  return (
    <form onSubmit={submit}>
      <ul>
        {fields}
        <br/>
        { isSaving
          ? <button className="btn" disabled><i className="fa fa-spinner fa-spin"></i></button>
          : <button className="btn" type="submit">Tallenna</button>
        }

      </ul>
    </form>
  );
};

const formField = (name, value, { label, type, placeholder, required }, onChange) => (
  <li className="form-field" key={name}>
    <label htmlFor={name}>{label}</label>
    <input type={type}
           placeholder={placeholder}
           name={name}
           value={value}
           onChange={onChange}
           required={required} />
  </li>
);

const saveSearchAgent = (userInfo) => {
  return jsonAjax.post('/_ajax/search-agent/create/', {...userInfo, ...getUrlData()});
};

const getUrlData = () => {
  let params = '';
  if (window.location.hash) {
    params = window.location.hash.substr(1);
  } else {
    params = window.location.search.substr(1);
  }
  return deparam(params);
};

export default SearchAgent;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/components/SearchAgent.js
 **/